// Configuración por institución para el portal público de pacientes.
//
// Instituciones que exigen el Nro. de Afiliado como campo obligatorio
// al momento de seleccionar la obra social / solicitar un turno.
//
// Para habilitar una nueva institución, agregá su idInstitucion a esta lista.
export const INSTITUCIONES_NRO_AFILIADO_OBLIGATORIO = [
  195, // CMSM
  436, // NATIVIDAD
];

// Devuelve true si la institución indicada requiere Nro. de Afiliado obligatorio.
export function requiereNroAfiliado(idInstitucion) {
  return INSTITUCIONES_NRO_AFILIADO_OBLIGATORIO.includes(idInstitucion);
}
